import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import MenuItem from '@material-ui/core/MenuItem';
import { ReduxState } from 'redux/types';

import CustomInput, { Props as CustomInputProps } from '../../../../components/CustomInput/CustomInput';
import Country from '../../../../types/Country';
import { UserRole } from '../../../../types/User';
import { FlexContainer } from './styled';

interface Props {
    baseInputProps: Omit<CustomInputProps, 'name'>;
    countries: Country[];
    fixedType?: UserRole;
}

const userTypes = ['customer', 'auditor', 'certifier', 'admin'];

const Form = (props: Props) => {
    const { baseInputProps, countries, fixedType } = props;

    const isCertifier = useSelector((state: ReduxState) => state.user.type) === 'certifier';

    const { t } = useTranslation();

    return (
        <>
            <FlexContainer>
                <CustomInput {...baseInputProps} name='name' />
                <CustomInput {...baseInputProps} name='surname' />
            </FlexContainer>

            <FlexContainer>
                <CustomInput {...baseInputProps} name='username' />
                <CustomInput {...baseInputProps} name='email' />
            </FlexContainer>

            <CustomInput {...baseInputProps} {...(isCertifier && { InputProps: {} })} name='password' type='password' />

            <FlexContainer>
                <CustomInput {...baseInputProps} name='type' select {...((fixedType || isCertifier) && { disabled: true })}>
                    {userTypes.map(type => {
                        return (
                            <MenuItem key={type} value={type}>
                                {t('user_types.' + type)}
                            </MenuItem>
                        );
                    })}
                </CustomInput>

                <CustomInput {...baseInputProps} name='companyReferent' select booleanValues>
                    <MenuItem value={'1'} >
                        {t('dialogs.user_details.company_referent_yes')}
                    </MenuItem>
                    <MenuItem value={'0'} >
                        {t('dialogs.user_details.company_referent_no')}
                    </MenuItem>
                </CustomInput>
            </FlexContainer>

            <FlexContainer>
                <CustomInput {...baseInputProps} name='phoneOffice' />
                <CustomInput {...baseInputProps} name='phoneMobile' />
            </FlexContainer>

            <CustomInput {...baseInputProps} name='address' />

            <FlexContainer>
                <CustomInput {...baseInputProps} name='postalcode' />
                <CustomInput {...baseInputProps} name='city' />
                <CustomInput {...baseInputProps} name='countryId' select >
                    {countries.map(country => {
                        return (
                            <MenuItem key={country.id} value={country.id}>
                                {country.name}
                            </MenuItem>
                        );
                    })}
                </CustomInput>
            </FlexContainer>

            <CustomInput {...baseInputProps} name='note' rows={5} multiline />
        </>
    );
};

export default Form;
